import { RootState } from "@src/store";

const ArcGoogleMapReducer = (state: RootState) => state.MapReducer;

export const selectMapZoom = (state: RootState) => ArcGoogleMapReducer(state).zoom;
export const selectMapType = (state: RootState) => ArcGoogleMapReducer(state).type;
export const selectMapCenter = (state: RootState) => ArcGoogleMapReducer(state).center;
export const selectMapLocation = (state: RootState) => ArcGoogleMapReducer(state).location;
export const selectRulerActive = (state: RootState) => ArcGoogleMapReducer(state).rulerActive;
export const selectRulerPoints = (state: RootState) => ArcGoogleMapReducer(state).rulerPoints;